import { render } from "./Nav.vue?vue&type=template&id=0c5ecc64&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0c5ecc64"

export default script